<form class="cell-verify" [name]="name" autocomplete="off" [formGroup]="form" novalidate
    [ngClass]="{'is-invalid': invalid}">
    <div class="cell-verify__inner">

        <div class="cell-verify__holder">
            <input directive-numbers-only [floats]="false" type="text" class="cell-verify__input"
                [ngClass]="{'is-invalid': invalid}" tabindex="1" (focus)="onFocus(d1)"
                (ngModelChange)="onKeyPress($event, 1)" formControlName="d1" minlength="1" maxlength="1" #d1>
        </div>

        <div class="cell-verify__holder -error">
            <input directive-numbers-only [floats]="false" type="text" class="cell-verify__input"
                [ngClass]="{'is-invalid': invalid}" tabindex="2" (focus)="onFocus(d2)"
                (ngModelChange)="onKeyPress($event, 2)" formControlName="d2" minlength="1" maxlength="1" #d2>
        </div>

        <div class="cell-verify__holder">
            <input directive-numbers-only [floats]="false" type="text" class="cell-verify__input"
                [ngClass]="{'is-invalid': invalid}" tabindex="3" (focus)="onFocus(d3)"
                (ngModelChange)="onKeyPress($event, 3)" formControlName="d3" minlength="1" maxlength="1" #d3>
        </div>

        <div class="cell-verify__holder">
            <input directive-numbers-only [floats]="false" type="text" class="cell-verify__input"
                [ngClass]="{'is-invalid': invalid}" tabindex="4" (focus)="onFocus(d4)"
                (ngModelChange)="onKeyPress($event, 4)" formControlName="d4" minlength="1" maxlength="1" #d4>
        </div>

    </div>
</form>